import React, { useState, Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  getCompanyEmployeeShift,
  updateCompanyEmployeeShift,
} from "../../actions/companyEmployeeShiftActions";

import Form from "./Form";
import {
  Grid,
  TextField,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { KeyboardDateTimePicker } from "@material-ui/pickers";
import { CommuteType } from "../../types/enums";
import { useTranslation } from "react-i18next";
import moment from "moment";

const UpdateCompanyEmployeeShiftForm = (props) => {
  const { t } = useTranslation();

  const [state, setState] = useState({
    startDateTime: moment(),
    endDateTime: moment(),
    commuteType: "",
    commuteAllowance: "",
    breakTimeSubstraction: "",
    distance: "",
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setIsLoading(true);
    props
      .getCompanyEmployeeShift(props.companyEmployeeId, props.shiftId)
      .then((response) => {
        setState((prev) => ({ ...prev, ...response }));
      })
      .catch(setErrorMessage)
      .finally(() => setIsLoading(false));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.persist();

    setIsLoading(true);
    props
      .updateCompanyEmployeeShift(props.companyEmployeeId, props.shiftId, state)
      .then(() =>
        setSuccessMessage("Medewerker van dienst wijzigen is voltooid."),
      )
      .catch(setErrorMessage)
      .finally(() => loadData());
  };

  const handleChange = (e) => {
    e.persist();
    setState((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <Fragment>
      <p>
        Indien u de tijden voor de medewerker leeg laat, worden de tijden van de
        dienst in acht genomen.
      </p>

      <Form
        onSubmit={handleSubmit}
        submitText="Wijzigen"
        isFetching={isLoading}
        successMessage={successMessage}
        errorMessage={errorMessage}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <KeyboardDateTimePicker
              clearable
              mask="__-__-____ __:__"
              id="startDateTime"
              name="startDateTime"
              label="Begindatum *"
              value={state.startDateTime}
              format={"L LT"}
              onChange={(m) =>
                setState((prev) => ({
                  ...prev,
                  startDateTime: m,
                }))
              }
              fullWidth
              ampm={false}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KeyboardDateTimePicker
              clearable
              mask="__-__-____ __:__"
              id="endDateTime"
              name="endDateTime"
              label="Einddatum *"
              value={state.endDateTime}
              format={"L LT"}
              onChange={(m) =>
                setState((prev) => ({
                  ...prev,
                  endDateTime: m,
                }))
              }
              fullWidth
              ampm={false}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <InputLabel htmlFor="commuteType">Type vervoer *</InputLabel>
            <Select
              id="commuteType"
              name="commuteType"
              value={state.commuteType}
              onChange={(e) =>
                setState((prev) => ({
                  ...prev,
                  commuteType: e.target.value || null,
                }))
              }
              fullWidth
            >
              <MenuItem value="">
                <em>Standaard</em>
              </MenuItem>
              {Object.values(CommuteType).map((v, i) => (
                <MenuItem
                  key={i}
                  value={v}
                  style={{
                    fontWeight: state.commuteType === v ? "500" : "normal",
                  }}
                >
                  {t(v)}
                </MenuItem>
              ))}
            </Select>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              type="number"
              id="breakTimeSubstraction"
              name="breakTimeSubstraction"
              label="Pauzevermindering (min.) *"
              value={state.breakTimeSubstraction}
              onChange={handleChange}
              fullWidth
              inputProps={{ min: "0", step: "1" }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              type="number"
              id="distance"
              name="distance"
              label="Afstand (km.) *"
              value={state.distance}
              disabled
              fullWidth
              inputProps={{ min: "0", step: ".01" }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              type="number"
              id="commuteAllowance"
              name="commuteAllowance"
              label="Reiskostenvergoeding"
              value={state.commuteAllowance}
              disabled
              fullWidth
              inputProps={{ min: "0", step: ".01" }}
            />
          </Grid>
        </Grid>
      </Form>
    </Fragment>
  );
};

UpdateCompanyEmployeeShiftForm.propTypes = {
  companyEmployeeId: PropTypes.number.isRequired,
  shiftId: PropTypes.string.isRequired,
  getCompanyEmployeeShift: PropTypes.func.isRequired,
  updateCompanyEmployeeShift: PropTypes.func.isRequired,
};

export default connect(null, {
  getCompanyEmployeeShift,
  updateCompanyEmployeeShift,
})(UpdateCompanyEmployeeShiftForm);



// WEBPACK FOOTER //
// ./src/components/forms/UpdateCompanyEmployeeShiftForm.js